import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/warning-icon-rounded.svg'


const _hoisted_1 = { class: "bg-transparent w-full h-[44px] rounded-primary-radius px-3 flex items-center justify-center border-2 border-primary-text-color" }
const _hoisted_2 = { class: "flex items-center gap-2" }
const _hoisted_3 = { class: "text-primary-text-color text-base leading-5 tracking-[0.01rem] font-semibold" }



type Props = {
  buttonText: string;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'QuestionnaireOutline',
  props: {
    buttonText: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("img", {
        src: _imports_0,
        alt: "Warning icon"
      }, null, -1)),
      _createElementVNode("span", _hoisted_3, _toDisplayString(__props.buttonText), 1)
    ])
  ]))
}
}

})